import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { StatusType } from '../../types/status.types';

@Component({
  selector: 'app-status-indicator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './status-indicator.component.html',
  styleUrls: ['./status-indicator.component.scss'],
})
export class StatusIndicatorComponent {
  @Input() status: StatusType = 'pending';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() showIcon: boolean = true;

  get statusText(): string {
    switch (this.status) {
      case 'approved':
        return 'APPROVED';
      case 'declined':
        return 'DECLINED';
      case 'eligible':
        return 'ELIGIBLE';
      case 'not-determined':
        return 'NOT DETERMINED';
      case 'pending':
        return 'PENDING';
      case 'na':
        return 'NA';
      default:
        return 'UNKNOWN';
    }
  }

  get statusIcon(): string {
    switch (this.status) {
      case 'approved':
      case 'eligible':
        return 'fas fa-check-circle';
      case 'declined':
        return 'fas fa-times-circle';
      case 'not-determined':
        return 'fas fa-minus-circle';
      case 'pending':
        return 'fas fa-minus-circle';
      case 'na':
        return '';
      default:
        return 'fas fa-minus-circle';
    }
  }
}
